export default __webpack_public_path__ + "static/media/bw-executive-function-tutorial-pop-up-step-1_en.ddbf7c04.svg";